export type BusinessType = 'barbershop' | 'salon' | 'spa' | 'clinic' | 'nail-salon' | 'masseuse' | 'retail';
export type FlowState = string;
export type FlowStateType = 'start' | 'interaction' | 'decision' | 'action' | 'terminal';

export interface FlowDefinition {
  id: string;
  name: string;
  description: string;
  steps: number;
}

export const FLOWS_BY_BUSINESS_TYPE: Record<BusinessType, FlowDefinition[]> = {
  barbershop: [
    { id: 'booking', name: 'Booking Flow', description: 'WhatsApp conversation flow for scheduling haircuts and beard trims', steps: 8 },
    { id: 'reschedule', name: 'Reschedule Flow', description: 'Customer-initiated booking reschedule via WhatsApp', steps: 5 },
    { id: 'cancel', name: 'Cancellation Flow', description: 'Booking cancellation with reason collection', steps: 4 },
    { id: 'reminder', name: 'Reminder Flow', description: 'Automated 24h appointment reminder with confirmation', steps: 3 },
  ],
  salon: [
    { id: 'booking', name: 'Booking Flow', description: 'Service selection, stylist preference, and time slot booking', steps: 10 },
    { id: 'reschedule', name: 'Reschedule Flow', description: 'Reschedule with stylist availability check', steps: 6 },
    { id: 'feedback', name: 'Feedback Flow', description: 'Post-visit satisfaction survey', steps: 4 },
    { id: 'reminder', name: 'Reminder Flow', description: 'Appointment reminder with prep instructions', steps: 3 },
  ],
  spa: [
    { id: 'booking', name: 'Booking Flow', description: 'Spa treatment booking with health questionnaire', steps: 9 },
    { id: 'package', name: 'Package Flow', description: 'Multi-session package purchase flow', steps: 6 },
    { id: 'reminder', name: 'Reminder Flow', description: 'Pre-visit instructions and arrival reminder', steps: 4 },
  ],
  clinic: [
    { id: 'booking', name: 'Consultation Booking', description: 'Medical consultation scheduling with intake form', steps: 8 },
    { id: 'followup', name: 'Follow-up Flow', description: 'Post-treatment follow-up and next steps', steps: 5 },
    { id: 'reminder', name: 'Appointment Reminder', description: 'Reminder with pre-visit preparation instructions', steps: 3 },
  ],
  'nail-salon': [
    { id: 'booking', name: 'Booking Flow', description: 'Nail service booking with design selection', steps: 7 },
    { id: 'maintenance', name: 'Maintenance Reminder', description: 'Gel/acrylic maintenance scheduling', steps: 4 },
    { id: 'reminder', name: 'Appointment Reminder', description: '24h reminder with nail prep tips', steps: 3 },
  ],
  masseuse: [
    { id: 'booking', name: 'Session Booking', description: 'Massage session booking with pressure preference', steps: 7 },
    { id: 'package', name: 'Package Flow', description: 'Multi-session discount package', steps: 5 },
    { id: 'reminder', name: 'Session Reminder', description: 'Pre-session hydration and arrival reminder', steps: 3 },
  ],
  retail: [
    { id: 'order', name: 'Order Flow', description: 'Product order via WhatsApp with payment', steps: 8 },
    { id: 'inquiry', name: 'Product Inquiry', description: 'Product availability and pricing questions', steps: 4 },
    { id: 'tracking', name: 'Order Tracking', description: 'Delivery status updates', steps: 3 },
  ],
};

export const STATE_TYPE_MAP: Record<string, FlowStateType> = {
  greeting: 'start',
  service_select: 'interaction',
  date_select: 'interaction',
  time_select: 'interaction',
  confirm: 'decision',
  payment: 'action',
  booked: 'terminal',
  cancelled: 'terminal',
};
